import useResources from "./use-resources";

export function useEdlSharedItems() {
  const {
    resources: edlSharedItems,
    error,
    isLoading,
  } = useResources("biens/edl-items/shared");

  return {
    edlSharedItems,
    error,
    isLoading,
  };
}

export function usePropertiesEdlItem(propertyId, item) {
  const {
    resources: propertiesEdlItem,
    error,
    isLoading,
  } = useResources(
    propertyId && item
      ? `biens/${propertyId}/edl-items/${item}/shared-with`
      : null,
  );

  return {
    propertiesEdlItem,
    error,
    isLoading,
  };
}

export default function useEdlItems(propertyId) {
  const root_path = `biens/${propertyId}/edl-items`;
  const {
    resources: edlItems,
    error,
    isLoading,
    mutate,
    axios,
    create,
    update,
    del,
    reorder: updateEdlItemsOrder,
  } = useResources(propertyId ? root_path : null);

  async function addSharedItem(id) {
    let newResource;
    await mutate(
      async (current) => {
        const response = await axios.post(`${root_path}/shared`, id);
        newResource = response.data;
        return [...current, newResource];
      },
      { revalidate: false },
    );
    return newResource;
  }

  async function duplicateEdlItem(id) {
    return mutate(
      async (current) => {
        const response = await axios.post(`${root_path}/${id}/duplicate`);
        return [...current, response.data];
      },
      { revalidate: false },
    );
  }
  async function importEdlItems(itemIds) {
    let newResource;
    await mutate(
      async () => {
        const response = await axios.put(`${root_path}/import`, itemIds);
        newResource = response.data;
        return newResource;
      },
      { revalidate: false },
    );
    return newResource;
  }

  return {
    edlItems,
    edlItemsOrder: edlItems?.map((item) => item.id),
    error,
    isLoading,
    duplicateEdlItem,
    updateEdlItem: update,
    updateEdlItemsOrder,
    addEdlItem: create,
    deleteEdlItem: del,
    addSharedItem,
    importEdlItems,
  };
}
